import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../common/custompagination";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import { formateDateWithMonth } from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import { SubscriptionTransactionList } from "../../services/subscriptionTransaction.services";

const TransactionTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const [list, setList] = useState([]);
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting] = useState({});
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});

  const breadcrumbs = [
    { title: t("contact-us.link_dashboard"), url: "/admin/dashboard" },
    { title: t("Transactiion"), url: "" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        SubscriptionTransactionList(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data?.data?.list : []);
            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            setTimeout(() => {
              setLoader(false);
            }, 500);
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
  };

  const getStatusBadge = (status) => {
    const badges = {
      active: "bg-success",
      trialing: "bg-warning",
      expired: "bg-danger",
      canceled: "bg-danger",
    };
    return (
      <span className={`badge ${badges[status] || "bg-secondary"} fs-10`}>
        {status ? status.charAt(0).toUpperCase() + status.slice(1) : "Unknown"}
      </span>
    );
  };

  const getPlatformBadge = (platform) => {
    const badges = {
      apple: "bg-success",
      android: "bg-info",
      manual: "bg-warning",
      other: "bg-secondary",
    };
    return (
      <span className={`badge ${badges[platform] || "bg-secondary"} fs-10`}>
        {platform ? platform.charAt(0).toUpperCase() + platform.slice(1) : "Other"}
      </span>
    );
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("Subscription Transactions")}
              </h6>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="form-group mb-0 me-3">
                  <select
                    className="form-control"
                    value={search.platform || ""}
                    onChange={(e) => prepareSearch("platform", e.target.value)}
                  >
                    <option value="">All Platforms</option>
                    <option value="apple">Apple</option>
                    <option value="android">Android</option>
                    <option value="manual">Manual</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group mb-0 me-3">
                  <select
                    className="form-control"
                    value={search.status || ""}
                    onChange={(e) => prepareSearch("status", e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="active">Active</option>
                    <option value="trialing">Trialing</option>
                    <option value="expired">Expired</option>
                    <option value="canceled">Canceled</option>
                  </select>
                </div>

                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="position-relative select_head">
                      <span>{t("list_heading_sno")}</span>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("User")}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <span>Platform</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <span>Transaction ID</span>
                      </div>
                    </th>
                    <th>
                      <div className="rating_head">
                        <span>Amount</span>
                      </div>
                    </th>
                    <th>
                      <div className=" text-center">
                        <span>Status</span>
                      </div>
                    </th>
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>Created At</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={10}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                {row ? ((page - 1) * itemperpage) + i + 1 : null}
                              </td>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  {row.user_datails?.profile_image ? (
                                    <img
                                      src={row.user_datails.profile_image}
                                      alt="User"
                                      className="avatar rounded-circle"
                                      style={{ width: 32, height: 32 }}
                                    />
                                  ) : (
                                    <div
                                      className="avatar rounded-circle bg-secondary"
                                      style={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}
                                    >
                                      {row.user_name?.charAt(0).toUpperCase() || 'U'}
                                    </div>
                                  )}
                                  <span>{row.user_name || "N/A"}</span>
                                </div>
                              </td>
                              <td>{getPlatformBadge(row.payment_type)}</td>
                              <td className="fw-bold text-primary">{row.transaction_id || "N/A"}</td>
                              <td>
                                {row.amount != null
                                  ? `${row.currency || 'USD'} ${Number(row.amount).toFixed(2)}`
                                  : "N/A"}
                              </td>
                              <td className=" text-center">
                                {getStatusBadge(row.payment_status)}
                              </td>
                              <td>
                                {row.createdAt
                                  ? formateDateWithMonth(row.createdAt)
                                  : "N/A"}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Transaction",
                    path: "/admin/subscription/transaction/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionTable;
